import React from 'react';

export default function Faq() {
  return <div className="h-60 mt-20">This is faq Page</div>;
}
